import { useMemo, useState, useEffect } from "react";
import ProdutoCard from "../Catalogo/ProdutoCard";

const GridCatalogoSimulado = ({
  produtos = [],
  busca = "",
  categoria = "",
  produtoIdSelecionado,
  setProdutoIdSelecionado,
  onFecharModal,
  carregando = false,
}) => {
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);

  // Filtra apenas os produtos que já foram carregados
  const produtosFiltrados = useMemo(() => {
    if (!Array.isArray(produtos)) return [];
    
    return produtos.filter((produto) => {
      const termoLower = busca.toLowerCase();
      const combinaBusca =
        busca.trim() === "" ||
        (produto.descricao?.toLowerCase().includes(termoLower) ?? false) ||
        (produto.estampa_cor?.toLowerCase().includes(termoLower) ?? false) ||
        (produto.marca?.toLowerCase().includes(termoLower) ?? false) ||
        (produto.tamanhos_disponiveis?.toLowerCase().includes(termoLower) ?? false) ||
        (produto.tags?.some((tag) => tag.nome.toLowerCase().includes(termoLower)) ?? false);

      const combinaCategoria =
        categoria === "" ||
        categoria === "todas" ||
        (produto.tags?.some((tag) => tag.nome === categoria) ?? false);

      return combinaBusca && combinaCategoria;
    });
  }, [produtos, busca, categoria]);

  useEffect(() => {
    if (produtoIdSelecionado) {
      const produto = produtos.find((p) => p.id === produtoIdSelecionado);
      if (produto) setProdutoSelecionado(produto);
    }
  }, [produtoIdSelecionado, produtos]);

  const fecharModal = () => {
    setProdutoSelecionado(null);
    onFecharModal?.();
  };

  return (
    <div className="w-full px-2 pt-3 pb-6 relative">
      {carregando && produtos.length === 0 ? (
        <div className="text-center text-gray-400 text-sm mt-4">Carregando...</div>
      ) : (
        <>
          <div className="grid grid-cols-2 gap-2">
            {produtosFiltrados.map((produto) => (
              <ProdutoCard
                key={produto.id}
                produto={produto}
                aoClicar={() => {
                  setProdutoSelecionado(produto);
                  setProdutoIdSelecionado?.(produto.id);
                }}
              />
            ))}
          </div>

          {produtosFiltrados.length === 0 && !carregando && (
            <div className="text-center text-gray-400 text-sm mt-4">
              Nenhum produto encontrado.
            </div>
          )}
        </>
      )}

      {produtoSelecionado && (
        <div className="absolute inset-0 bg-white z-20 overflow-y-scroll p-4 rounded-xl">
          <button
            onClick={fecharModal}
            className="absolute top-2 right-3 text-gray-500 hover:text-red-500 text-sm font-bold"
          >
            ✕
          </button>

          <div className="text-center">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}${produtoSelecionado.fotos[0]?.url}`}
              alt={produtoSelecionado.descricao}
              className="w-full h-auto rounded-lg mb-4"
            />
            <h3 className="text-lg font-semibold mb-1">
              {produtoSelecionado.descricao}
            </h3>
            <p className="text-sm text-gray-600 mb-1">
              Marca: {produtoSelecionado.marca}
            </p>
            {produtoSelecionado.estampa_cor && (
              <p className="text-sm text-gray-600 mb-1">
                Cor/Estampa: {produtoSelecionado.estampa_cor}
              </p>
            )}
            {produtoSelecionado.tamanhos_disponiveis && (
              <p className="text-sm text-gray-600 mb-1">
                Tamanhos: {produtoSelecionado.tamanhos_disponiveis}
              </p>
            )}
            {produtoSelecionado.tags?.length > 0 && (
              <p className="text-sm text-gray-500 mt-2">
                Tags: {produtoSelecionado.tags.map((t) => t.nome).join(", ")}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default GridCatalogoSimulado;